import type { ReactNode } from 'react';

export const symbol_60fps: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M335-200H160q-33.33 0-56.67-23.33Q80-246.67 80-280v-400q0-33.33 23.33-56.67Q126.67-760 160-760h172q16.67 0 28.33 11.74Q372-736.53 372-719.76q0 16.76-11.67 28.26Q348.67-680 332-680H160v138h175q33.33 0 56.67 23.33Q415-495.33 415-462v182q0 33.33-23.33 56.67Q368.33-200 335-200ZM160-462v182h175v-182H160Zm422 182h218v-400H582v400Zm0 80q-33.33 0-56.67-23.33Q502-246.67 502-280v-400q0-33.33 23.33-56.67Q548.67-760 582-760h218q33.33 0 56.67 23.33Q880-713.33 880-680v400q0 33.33-23.33 56.67Q833.33-200 800-200H582Z"
		/>
	</svg>
);
